export const RenderTimes = (n, iterator) => {
  console.log(n)
  var accum = Array(Math.max(0, n))
  for (var i = 0; i < n; i++) accum[i] = iterator.call(this, i)
  return accum
}
